import {Component, h} from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import {PostType, TopicTypes} from './Types'
import TopicRepliesEmptyStatus from './TopicRepliesEmptyStatus'
import TopicReply from './TopicReply'
import { LikedUserType } from './LikedUsers'

interface Props {
  type: TopicTypes,
  currentUser: LikedUserType,
  topicId: number,
  topicAuthorId: number,
  replies: Array<PostType>
}

interface State {}

class TopicReplies extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {}
  }
  render ({ replies, topicId, topicAuthorId, currentUser, type }: Props) {
    return (
      <div className='box' id='comments'>
        <header className='list__items--header qa-topic-reply-box-header'>
          <h3 className='qa-total-replies'>
            <Phrase p={replies.length ? '{n} Reply|{n} Replies' : 'no.replies'} count={{ n: replies.length.toString() }} />
          </h3>
        </header>
        {
          replies.length ? (
            <div>
              {
                replies.map((reply, idx) => <TopicReply
                  currentUser={currentUser}
                  displayAuthor={reply.author.id === topicAuthorId}
                  topicId={topicId}
                  reply={reply}
                  type={type}
                  isLastItem={replies.length === idx + 1}
                />)
              }
            </div>
          ) : (
            <TopicRepliesEmptyStatus />
          )
        }
      </div>
    )
  }
}

export default TopicReplies
